"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.counterPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _util = require("../util");

require("./counter.less");

var _incrementalCounter = _interopRequireDefault(require("./incremental-counter"));

var _markdown = _interopRequireDefault(require("../../markdown"));

var _commonPropTypes = _interopRequireDefault(require("../../common-prop-types"));

var _sections = require("../sections");

var _buttonLink = require("../button-link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Array of counter layouts
 */
var COUNTER_POSITIONS = ['Row Layout', 'Column Layout'];
/**
 * Counter Parent that allows for the set up and use of the Incremental Counter
 * component within a styled text layout and shows/hides different parts
 * depending on the response values.
 *
 * @param {Object} props.callToActionButton
 * @param {String} props.className
 * @param {String} props.counterPosition
 * Text that appends to counter on mobile views
 * @param {String} props.endMobileText
 * Text that appends to counter. Hides if it's mobile counterpart has a value
 * @param {String} props.endText
 * Int that the counter stops increasing at
 * @param {Integer} props.endVal
 * Allows hiding of counter on mobile views
 * @param {Boolean} props.hasCounterOnMobile
 * Text that can be showed instead of the counter
 * @param {String} props.mobilePlaceHolder
 * Allows custom underline to be placed under counter
 * @param {Boolean} props.showUnderline
 * Time between changes in seconds
 * @param {Float} props.speed
 * Text that prepends to counter on mobile views
 * @param {String} props.startMobileText
 * Text that prepends to counter. Hides if it's mobile counterpart has a value
 * @param {String} props.startText
 * Int that the counter could start at
 * @param {startVal} props.startVal
 * @param {Object} props.stringSubstitutions
 */

var Counter = function Counter(_ref) {
  var callToActionButton = _ref.callToActionButton,
      className = _ref.className,
      counterPosition = _ref.counterPosition,
      endMobileText = _ref.endMobileText,
      endText = _ref.endText,
      endVal = _ref.endVal,
      hasCounterOnMobile = _ref.hasCounterOnMobile,
      mobilePlaceHolder = _ref.mobilePlaceHolder,
      showUnderline = _ref.showUnderline,
      speed = _ref.speed,
      startMobileText = _ref.startMobileText,
      startText = _ref.startText,
      startVal = _ref.startVal,
      stringSubstitutions = _ref.stringSubstitutions;

  var endTextContent = endText && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "".concat(endMobileText && 'hide-mobile', " counter-text"),
    source: (0, _util.stringSubstitution)(endText, stringSubstitutions)
  });

  var startTextContent = startText && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "".concat(startMobileText && 'hide-mobile', " counter-text"),
    source: (0, _util.stringSubstitution)(startText, stringSubstitutions)
  });
  /** FOR MOBILE */


  var endMobileTextContent = endMobileText && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "counter-text-mobile",
    source: (0, _util.stringSubstitution)(endMobileText, stringSubstitutions)
  });

  var startMobileTextContent = startMobileText && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "counter-text-mobile",
    source: (0, _util.stringSubstitution)(startMobileText, stringSubstitutions)
  });

  var mobilePlaceHolderContent = mobilePlaceHolder && !hasCounterOnMobile && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "counter-text-mobile counter-placeholder ".concat(showUnderline && 'underline'),
    source: (0, _util.stringSubstitution)(mobilePlaceHolder, stringSubstitutions)
  });

  var ctaButton = callToActionButton && (0, _sections.getWidget)(callToActionButton);

  var counter = /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(showUnderline && 'underline', " ").concat(!hasCounterOnMobile && 'hide-mobile', " counter-text")
  }, /*#__PURE__*/_react["default"].createElement(_incrementalCounter["default"], {
    end: endVal,
    start: startVal,
    speed: speed || 1.0
  }));

  var counterLayout = /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(counterPosition.toLowerCase().replace(' ', '-'))
  }, startTextContent, startMobileTextContent, counter, mobilePlaceHolderContent, endTextContent, endMobileTextContent);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "counter-parent ".concat(className)
  }, counterLayout, ctaButton);
};

var counterPropTypes = {
  callToActionButton: _propTypes["default"].shape({
    fields: _propTypes["default"].shape(_buttonLink.buttonLinkPropTypes)
  }),
  className: _propTypes["default"].string,
  counterPosition: _propTypes["default"].oneOf(COUNTER_POSITIONS),
  endMobileText: _propTypes["default"].string,
  endText: _propTypes["default"].string,
  endVal: _propTypes["default"].number,
  hasCounterOnMobile: _propTypes["default"].bool,
  mobilePlaceHolder: _propTypes["default"].string,
  showUnderline: _propTypes["default"].bool,
  speed: _propTypes["default"].number,
  startMobileText: _propTypes["default"].string,
  startText: _propTypes["default"].string,
  startVal: _propTypes["default"].number,
  stringSubstitutions: _commonPropTypes["default"].stringSubstitutions
};
exports.counterPropTypes = counterPropTypes;
Counter.propTypes = counterPropTypes;
Counter.defaultProps = {
  callToActionButton: null,
  className: '',
  counterPosition: COUNTER_POSITIONS[0],
  endMobileText: null,
  endText: null,
  endVal: null,
  hasCounterOnMobile: true,
  mobilePlaceHolder: null,
  showUnderline: false,
  speed: null,
  startMobileText: null,
  startText: null,
  startVal: null,
  stringSubstitutions: {}
};
(0, _sections.registerWidget)('counter', Counter);
var _default = Counter;
exports["default"] = _default;